import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import Accueil from "./pages/Accueil";
import CarteRestaurant from "./pages/CarteRestaurant";
import CartePetitDejeuner from "./pages/CartePetitDejeuner";
import CarteGourmande from "./pages/CarteGourmande";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "auto" : "auto" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Accueil />} />
            <Route path="/carte-restaurant" element={<CarteRestaurant />} />
            <Route
              path="/carte-petit-dejeuner"
              element={<CartePetitDejeuner />}
            />
            <Route path="/carte-gourmande" element={<CarteGourmande />} />
            <Route path="*" element={<Accueil />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
